@keyframes anim {
    0% {
        opacity: 0.6;
    }
    100% {
        opacity: 0;
    }
}

.animEl {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: var(--kl-color);

    animation: anim 500ms linear both;
}
